import CRUDMixin from "./CRUDMixin.js";
import _ from 'lodash';
export default {
    mixins: [CRUDMixin],
    data() {
        return {
            viewModel: this.newViewModel(),
            
            countries: [],
            decidingBodies: [],
            instances: [],
            legalProcedures: [],
            ipCategoryItems: [],
            showIPSpecialisationNature: false,
            isDecidingBodyNotListed: false,
            isJurisdictionOther: false,
            activeStep: 0,
            showSocial: false,
            isAnimated: true,
            isRounded: true,
            isStepsClickable: true,
            isValidating: false,
            hasNavigation: true,
            customNavigation: true,
            isProfileSuccess: false,
            confirmKeys: window.confirmKeys,
            onPasteSeparator: [],
            prevIcon: 'chevron-left',
            nextIcon: 'chevron-right',
            labelPosition: 'bottom',
            mobileMode: 'minimalist',
            loadingInstances: false,
            loading: true,
            showSubmit: true,
            showComplete: false,
            hasPossibleDuplicate: false,
            hasPossibleDuplicateCaseCitation: false,
            possibleDuplicateCases: [],
            possibleDuplicateCaseCitations: [],
            showDuplicateOn: 'caseName',
            getDataLoading: false,
            isDataChanged: false,
            isTreeSelectFlat: true

        }

    },  
   
    methods: {
        formatDate: function (value) {
            if (value) {
                const localDate = moment(value).local();
                return localDate.format("YYYY-MM-DD");
            }
        },
        caseCitationBeforeAdding: function (val) {

            this.checkDuplicateCaseCitation(val);
            return true;
        },
        checkDuplicate: function (val) {
            let freeText = val;
            if (val && !this.loading) {

                this.$services.caseLaws.checkDuplicate({
                    id: this.viewModel.id,
                    freeText: freeText,
                    filterSearchTextFields: ['caseName'],
                    isCustomSearch: false
                })
                    .then((data) => {
                        this.hasPossibleDuplicate = data.hasPossibleDuplicate;
                        this.possibleDuplicateCases = data.possibleDuplicateCases;
                      
                        if (data.hasPossibleDuplicate) {


                            this.viewModel.errors.CaseName = ["This case may already be in the Digest. Please check <a href='" + window.searchUrl + "' target='_blank'>here</a> to avoid duplication."];

                            this.showDuplicateOn = 'caseName';
                             
                        } else {
                            delete this.viewModel.errors.CaseName;

                           
                        }
                    });
            }

        },
        checkDuplicateCaseCitation: function (val) {
            
            if (!this.loading) {


                var caseCitations = this.viewModel.caseCitations;

                if (val && !caseCitations.includes(val)) caseCitations.push(val);
                this.$services.caseLaws.checkDuplicateCaseCitation({
                    id: this.viewModel.id,
                    filterSearchTextFields: ['caseCitations/name'],
                    caseCitations: caseCitations
                })
                    .then((data) => {
                        this.hasPossibleDuplicateCaseCitation = data.hasPossibleDuplicate;
                        this.possibleDuplicateCaseCitations = data.possibleDuplicateCases;

                        if (data.hasPossibleDuplicate) {

                            //const notif = this.$buefy.notification.open({
                            //    duration: 5000,
                            //    message: `This case may already be in the Digest. Please check here to avoid duplication.`,
                            //    position: 'is-bottom-right',
                            //    type: 'is-danger',
                            //    hasIcon: true
                            //})

                            this.viewModel.errors.CaseCitations = ["This case may already be in the Digest. Please check <a href='" + window.searchUrl + "' target='_blank'>here</a> to avoid duplication."];
                            console.log(this.viewModel.errors.CaseCitations)

                            this.showDuplicateOn = 'caseCitations';

                        } else {
                            delete this.viewModel.errors.CaseCitations;

                          
                        }
                    });
            }

        },
        validateIPCategoryIfNone: function (val) {
            return this.viewModel.iPCategories.includes(val);
        },
        nextButton: async function (next) {
            var proceed = false;
            this.isValidating = true;
            if (!this.isReadOnly) {
                switch (this.activeStep) {
                    case 0:
                        proceed = await this.validateContributorInfo();

                        break;
                    case 1:
                        proceed = await this.validateCaseDetails();

                        break;
                    case 2:
                        proceed = await this.validateProvisionDetails();

                        break;
                    case 3:
                        proceed = await this.validateDecisionDetails();
                        break;
                }
            } else proceed = true;

            window.scrollTo(0, 0);


            if (proceed) next.action();
            this.isValidating = false;


        },
        prevButton: function (prev) {

            prev.action();

        },
        backToList: function () {
            window.location.href = this.listUrl + this.setParams();

        },
        setParams: function () {
            const url = new URL(window.location.href);
            const statuses = url.searchParams.get("statuses");
            const countryIds = url.searchParams.get("countryIds");
            const freeText = url.searchParams.get("freeText");
            const decidingBodyIds = url.searchParams.get("decidingBodyIds");
            const pageSize = url.searchParams.get("pageSize");

            let qs = '';
            if (statuses && statuses.length > 0) {
                qs += `?statuses=${encodeURIComponent(statuses)}`;
            }
            if (countryIds && countryIds.length > 0) {
                if (qs) { qs += '&'; } else { qs += '?' }
                qs += `countryIds=${encodeURIComponent(countryIds)}`;
            }
            if (decidingBodyIds && sdecidingBodyIds.length > 0) {
                if (qs) { qs += '&'; } else { qs += '?' }
                qs += `decidingBodyIds=${encodeURIComponent(decidingBodyIds)}`;
            }
            if (freeText) {
                if (qs) { qs += '&'; } else { qs += '?' }
                qs += `freeText=${encodeURIComponent(freeText)}`;
            }
            if (pageSize) {
                if (qs) { qs += '&'; } else { qs += '?' }
                qs += `pageSize=${encodeURIComponent(pageSize)}`;
            }
            return qs;

        },
        newViewModel: function () {
            return {
                id: 0,
                firstName: '',
                lastName: '',
                position: '',
                affiliation: '',
                emailAddress: window.userEmail,
                jurisdictionId: null,
                jurisdictionOther: null,
                decidingBodyId: null,
                decidingBodyOther: null,
                instanceId: null,
                specialisedIPVal: null,
                specialisedIP: null,
                specialisedIPNature: '',
                decisionDate: null,
                plaintiffs: [],
                defendants: [],
                caseCitations: [],
                legalProcedureId: null,
                iPCategories: [],
                provisions: [],
                parisConventions: [],
                berneConventions: [],
                romeConventions: [],
                washingtonTreaties: [],
                attachments: [],
                languageOfDecisionId: null,
                crossReferences: [],
                relevantLegislations: [],
                notes: null,
                relevantCommentary: null,
                isDraft: false,
                ignoreDuplicate: false,
                statusId: 1,
                dateOfSubmission: null,
                dateOfSubmissionString: null,
                ShowSubmitterInfoInPublic: false,
                errors: {
                }
            }
        },
        getCountriesForDropdown: async function () {
            return this.$services.countries.getForDropdown({
                language: this.language
            })
                .then((data) => {
                    this.countries = data.items;
                    return data;
                });
        },
        getDecidingBodiesForDropdown: async function () {
           return await this.$services.decidingBodies.getForDropdown({
                language: this.language
            })
                .then((data) => {
                    this.decidingBodies = data.items;
                    return data;
                });
        },
        getInstancesForMultiRadioButton: async function () {
            return await this.$services.instances.getForMultiRadioButton({
                language: this.language,
                includeDisplayOrder: true
            })
                .then((data) => {
                    this.instances = data.items;
                    return data;
                });
        },
        getLegalProceduresForDropdown: async function () {
            return await this.$services.legalProcedures.getForDropdown({
                language: this.language
            })
                .then((data) => {
                    this.legalProcedures = data.items;
                    return data;
                });
        },
        getIPCategoriesForDropdown: async function () {
           return  await this.$services.ipCategories.getForDropdown({
                language: this.language
            })
                .then((data) => {
                    this.ipCategoryItems = data.items;
                    return data;
                });
        },
        validateContributorInfo:  async function () {
            return await this.$services.caseLaws.validateContributorInformation(this.viewModel)
                .then((response) => {
                    if (response.status !== 200) {
                        this.viewModel.errors = response.data.errors;
                        return false;
                    } else return true;
                });
        },
        validateCaseDetails: async function () {
            if (this.hasPossibleDuplicate || this.hasPossibleDuplicateCaseCitation) {
                const { result, dialog } = await this.$buefy.dialog.confirm({
                    title: 'Possible Duplicate',
                    message: 'Detected possible duplicate, do you want to continue?',
                    confirmText: 'Ignore',
                    type: 'is-warning',
                    hasIcon: true,
                    //closeOnConfirm: false,
                    onConfirm: async(value, { close }) => {
                        this.viewModel.ignoreDuplicate = true;
                        
                    }
                });
                if (!result) return false;
                return await this.$services.caseLaws.validateCaseDetails(this.viewModel)
                    .then((response) => {
                        if (response.status !== 200) {
                            this.viewModel.errors = response.data.errors;
                         

                            return false;
                        } else return true;

                        close();

                    });

            } else {
                return await this.$services.caseLaws.validateCaseDetails(this.viewModel)
                    .then((response) => {
                        if (response.status !== 200) {
                            this.viewModel.errors = response.data.errors;
                            if (response.data.errors.hasOwnProperty('DuplicateCaseCitations')) {
                                this.hasPossibleCaseCitationDuplicate = true;
                                this.checkDuplicateCaseCitation();
                            }
                            if (response.data.errors.hasOwnProperty('DuplicateCaseName')) {
                                console.log("test")
                                this.hasPossibleDuplicate = true;
                                this.checkDuplicate(this.viewModel.caseName);
                            }
                            return false;
                        } else return true;
                    });
            }

            
        },
        validateProvisionDetails: async function () {
            return await this.$services.caseLaws.validateProvisionDetails(this.viewModel)
                .then((response) => {
                    if (response.status !== 200) {
                        this.viewModel.errors = response.data.errors;
                        return false;
                    } else return true;
                });
        },
        validateDecisionDetails: async function () {
            return await this.$services.caseLaws.validateDecisionDetails(this.viewModel)
                .then((response) => {
                    if (response.status !== 200) {
                        this.viewModel.errors = response.data.errors;
                        return false;
                    } else return true;
                });
        },
        submit: async function (isSave) {
            this.isSaving = true;
            var model = Object.assign({}, this.viewModel);

            //if (!isSave) {
            //    switch (model.statusId) {
            //        case 1
            //    }
            //}
            model.statusId = !isSave ? model.statusId != 1 ? model.statusId : 1 : 2;
            if (this.isEdit) {
               return await this.$services.caseLaws.edit(model)
                    .then((response) => {
                        this.isSaving = false;
                        if (response.status !== 200) {
                            this.viewModel.errors = response.data.errors;
                        }
                        else {
                            this.$buefy.toast.open(`Saved.`);
                            if (isSave) this.backToList();
                        }
                    });
            } else
              return  await this.$services.caseLaws.create(model)
                    .then((response) => {
                        this.isSaving = false;
                        if (response.status !== 200) {

                            this.viewModel.errors = response.data.errors;
                            //this.showErrorDialog("Submission", "test");
                        }
                        else {
                            this.viewModel.id = response.data.id;
                            if (this.viewModel.id && this.viewModel.id != 0) {
                                //var searchParams = new URLSearchParams(window.location.search)
                                //searchParams.set("id", response.data.id);
                                //var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                                //history.pushState(null, '', newRelativePathQuery);
                                this.isEdit = true;
                            }
                           

                            if (isSave) this.backToList();
                        }
                    });
        },
        update: async function (isFinal) {
            this.isSaving = true;
            var model = this.viewModel;
            model.isDraft = false;
            model.statusId = !isFinal && model.statusId != 7 ? 4 : 7;
            if (this.isEdit) {
               return await this.$services.caseLaws.edit(model)
                    .then((response) => {
                        this.isSaving = false;
                        if (response.status !== 200) {
                            this.viewModel.errors = response.data.errors;
                        }
                        else {
                            this.backToList();
                        }
                    });
            }
        },
        getData: async function (id) {
            this.loading = true;
            this.getDataLoading = true;

            return await this.$services.caseLaws.getById({ id: id })
                .then((viewModel) => {
                    viewModel.errors = {};

                    this.viewModel = viewModel;

                    if (!this.isReadOnly) {

                        if (window.isAdmin) {
                            this.showSubmit = true;
                        } else if ((this.viewModel.statusId == 1 ||
                            this.viewModel.statusId == 2 ||
                            this.viewModel.statusId == 3 ||
                            this.viewModel.statusId == 6) &&
                            (!window.isAdmin && window.userEmail == viewModel.submitter)) {
                            this.showSubmit = true;
                        }
                    } else {
                        this.showSubmit = false;
                    }
                    this.showSubmit = !this.isReadOnly && (this.viewModel.statusId == 1 || this.viewModel.statusId == 2 || this.viewModel.statusId == 3 || this.viewModel.statusId == 6) && ((!window.isAdmin && window.userEmail == viewModel.submitter) || window.isAdmin);;
                    this.showComplete = this.viewModel.statusId == 4 || (!window.isAdmin || this.viewModel.statusId == 7);
                    this.loading = false;
                    setTimeout(() => {
                        this.getDataLoading = false;
                        this.loading = false;
                        this.isDataChanged = false;
                    }, 500);
                });
        },
        showErrorDialog: function (title, message) {
            this.$buefy.dialog.alert({
                title: htmlEntity.decode(title),
                message: htmlEntity.decode(message),
                type: 'is-danger',
                hasIcon: true,
                confirmText: htmlEntity.decode(window.labels.ok)
            })
        },
        getNotListedDecidingBody: function () {

        },
        openCase: function (item) {
            if (item) {
                window.open('/' + window.currentLanguage + '/Search/Details/' + item.id, '_blank');
            }
        },
        getUserProfile: async function () {
         
            if ((this.viewModel.id == 0 || this.viewModel.id == null)) {
                return await this.$services.users.getProfile({})
                    .then((viewModel) => {
                        viewModel.errors = {};
                        this.viewModel.firstName = viewModel.firstName;
                        this.viewModel.lastName = viewModel.lastName;
                        this.viewModel.emailAddress = viewModel.email;
                        this.viewModel.affiliation = viewModel.organizationName;
                        this.viewModel.position = viewModel.position;
                        return viewModel;
                    });
            }
           
        },
        onKeydown: function (e) {
            if (e.keyCode == 9) {

                e.preventDefault();
            }
        }

    },
    watch: {
        showSubmit: function (val) {
        },
        viewModel: {
            deep: true,
            handler(val) {
                if (this.loading) return;
                this.isDataChanged = true;
            }
        },  
        'isDataChanged': function () {

        },
        'viewModel.specialisedIPVal': {
            handler(val) {

                if (this.loading) return;
                this.viewModel.specialisedIP = val === "True" ? true : val === "False" ? false : null;
            },
            deep: true
        },
        'viewModel.decidingBodyId': function (val) {

            if (this.loading) return;
            var notListed = this.decidingBodies.find(x => x.text == "Not listed" || x.isNotListed);

            if (notListed) this.isDecidingBodyNotListed = Number(val) === Number(notListed.value);
        },
        'viewModel.caseName': function (val) {
            //if (oldVal === undefined) {
            //    return
            //}
            if (val && !this.loading && !this.getDataLoading) {

                this.debounceCheckDuplicate(this.$options.filters.stripParagraphTags(val));

            }
        }
    },
    created() {

        this.debounceCheckDuplicate = _.debounce(this.checkDuplicate, 1000);
    },
    computed: {
        hasCrossReferences() {

            return this.viewModel.crossReferences && this.viewModel.crossReferences.length > 0;
        }
    },
    mounted() {
        this.loading = true;
        axios.all([this.getCountriesForDropdown(),
        this.getDecidingBodiesForDropdown(),
        this.getInstancesForMultiRadioButton(),
        this.getLegalProceduresForDropdown(),
            this.getIPCategoriesForDropdown(),
            this.getUserProfile()])
            .then(axios.spread((c, db, i, lp, ic,p) => {

                if (this.id) {
                    this.getData(this.id);
                }
                else {
                    this.loading = false;
                }
            }));

    }
}